module.exports = __webpack_public_path__ + "static/img/25.a4bd14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/25.png
// module id = FHbf
// module chunks = 1